const container = document.querySelector('.js-error-text-move');
const errorMessages = [...document.querySelectorAll('.js-error-text-move .error')];

const containerNameOfContactPage = document.querySelector('.js-error-text-move-contact-name');
const errorMessagesNameOfContactPage = [...document.querySelectorAll('.js-error-text-move-contact-name .error')];

const containerKanaOfContactPage = document.querySelector('.js-error-text-move-kana-name');
const errorMessagesKanaOfContactPage = [...document.querySelectorAll('.js-error-text-move-kana-name .error')];

const containerAgreeOfContactPage = document.querySelector('.js-error-text-move-agree');
const errorMessagesAgreeOfContactPage = [...document.querySelectorAll('.js-error-text-move-agree .error')];

if(errorMessages){
  errorMessages.forEach((e) => {
    container.appendChild(e);
  });
}

if(errorMessagesNameOfContactPage){
  errorMessagesNameOfContactPage.forEach((e) => {
    containerNameOfContactPage.appendChild(e);
  });
}

if(errorMessagesKanaOfContactPage){
  errorMessagesKanaOfContactPage.forEach((e) => {
    containerKanaOfContactPage.appendChild(e);
  });
}

if(errorMessagesAgreeOfContactPage){
  errorMessagesAgreeOfContactPage.forEach((e) => {
    containerAgreeOfContactPage.appendChild(e);
  });
}